import { Component, Inject, Input } from 'angular-ts-decorators';
import { IProductWithAttributes } from '@gn-audio/core/api/product-catalogue/models';
import { ProductAttributeKey } from '@gn-audio/core/common/enums';

import { isColorBright } from './utils/is-color-bright';

import template from './hero-customizer-v3-image-slider.component.html';
import { customPaging } from './utils/custom-paging';
import { IHeroCustomizerSliderItem } from '../models/hero-customizer-slider-item';

@Component({
  selector: 'heroCustomizerV3ImageSlider',
  template,
})
export class HeroCustomizerV3ImageSliderComponent {
  public static $inject: ReadonlyArray<string> = [];

  @Input() public group?: IProductWithAttributes;
  @Input() public lifestyleImages?: string[];
  @Input() public readonly is3dRenderingEnabled?: boolean;

  public sliderItems?: IHeroCustomizerSliderItem[];
  private iconColor: string;
  private iconColorToRemove: string;

  constructor(@Inject('$element') private $element: JQLite) {}
  
  public ngOnChanges() {
    this.sliderItems = undefined;
    const maxNumberOfImages = 4;
    
    if (this.group) {
      this.sliderItems = this.group.images
        .slice(0, maxNumberOfImages)
        .filter((x: IHeroCustomizerSliderItem) => Boolean(x.url))
        .concat((this.lifestyleImages || []).map((x: string) => ({ url: x })));
  
      if (this.is3dRenderingEnabled && this.productRenderingUuid) {
        this.sliderItems.push({ is3DView: true });
      }
  
      this.updateSliderColor();
    }
  }

  public onSlickInit(): void {
    const slider = this.$element.find('.hero-customizer-v3-image-slider');
    const sliderElements = this.$element.find('.slick-prev, .slick-next');
    const openGalleryElements = this.$element.find('.hero-customizer-v3-image-slider__open-gallery, .hero-customizer-v3__view-in-3d-icon');
  
    slider.css('display', 'flex');

    this.modifyClass(sliderElements, this.iconColor, this.iconColorToRemove);
    this.modifyClass(openGalleryElements, this.iconColor, this.iconColorToRemove);
  }
  
  private updateSliderColor(): void {
    const groupBrandColor: string | undefined = this.group.attributes?.find(
      (attribute) =>
        attribute.key === ProductAttributeKey.ProductBrandColorPublicWeb
    )?.value;
    
    const sliderColor = `--color-${groupBrandColor || 'beige'}`;
    const colorHexValue: string = getComputedStyle(document.documentElement).getPropertyValue(sliderColor);
    const isBrightColor = isColorBright(colorHexValue);
    this.iconColor = isBrightColor ? 'black' : 'white';
    this.iconColorToRemove = isBrightColor ? 'white' : 'black';
    
    document.documentElement.style.setProperty(
      '--slick-slider-background-color',
      `var(${sliderColor})`
    );

    this.onSlickInit();
  }
 
  private modifyClass(elements: JQuery, classToAdd: string, classToRemove: string): void {
    elements.removeClass(classToRemove).addClass(classToAdd);
  }

  public get isSingleImage(): boolean {
    return this.sliderItems && this.sliderItems.length === 1;
  }

  public get productRenderingUuid(): string {
    return this.group?.attributes?.find(
      (attribute) => attribute.key === ProductAttributeKey.Meta3dRenderingUuid
    )?.value;
  }

  public customPaging(index: number): string {
    return customPaging(this.sliderItems, index, this.group.productName);
  }
}
